// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* Should be above other elements */
  }
  
  /* Modal Content */
  .modal-content {
    background-color: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    max-width: 600px; /* Or any desired width */
    width: 90%;
    max-height: 80vh; /* Limit height */
    display: flex;
    flex-direction: column;
    position: relative;
  }
  
  /* Especially for NonFeatureColumnModal */
  .modal-content.non-feature-modal {
      max-width: 500px; /* Slightly narrower */
  }
  
  /* Close Button */
  .close-modal-button {
    position: absolute;
    top: 10px;
    right: 15px;
    background: none;
    border: none;
    font-size: 2rem;
    cursor: pointer;
    color: #aaa;
  }
  .close-modal-button:hover {
    color: #333;
  }
  
  
  /* Modal Title */
  .modal-content h2 {
    margin-top: 0;
    margin-bottom: 20px;
    text-align: center;
    color: #333;
  }
  
  /* Fetch Button */
  .fetch-all-columns-button {
    margin-bottom: 15px;
    padding: 10px 15px;
  }
  
  /* Search Input */
  .search-input {
    width: calc(100% - 22px); /* Account for padding */
    padding: 10px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
  }
  
  /* Column List */
  .column-list {
    max-height: 40vh; /* Scroll for list */
    overflow-y: auto;
    border: 1px solid #eee;
    padding: 10px;
    margin-bottom: 20px;
    background-color: #f9f9f9;
  }
  
  /* Column Item */
  .column-item {
    padding: 8px 5px;
    border-bottom: 1px solid #eee;
  }
  .column-item:last-child {
    border-bottom: none;
  }
  
  .column-item label {
    display: flex; /* Align checkbox and text */
    align-items: center;
    cursor: pointer;
  }
  
  .column-item input[type="checkbox"] {
    margin-right: 10px;
  }
  
  /* Loading and Error Messages */
  .loading-message, .error-message {
      padding: 10px;
      margin-bottom: 15px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
  }
  
  .error-message {
      color: #dc3545; /* Red */
      background-color: #f8d7da;
      border: 1px solid #f5c6cb;
      border-radius: 4px;
  }
  
  .loading-message .spinner {
      margin-right: 10px;
  }
  
  
  /* Modal Actions (Done button container) */
  .modal-actions {
      display: flex;
      justify-content: flex-end; /* Align button to right */
      margin-top: 15px;
  }
  
  /* General Button Styling (can inherit from App.css if available) */
  .button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
    margin-left: 10px; /* Space between buttons */
  }
  
  .button-primary {
    background-color: #007bff;
    color: white;
  }
  .button-primary:hover {
    background-color: #0056b3;
  }`, "",{"version":3,"sources":["webpack://./src/css/step6_modal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,mCAAmC;EACpD;;EAEA,kBAAkB;EAClB;IACE,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB,EAAE,yBAAyB;IAC3C,UAAU;IACV,gBAAgB,EAAE,iBAAiB;IACnC,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,yCAAyC;EACzC;MACI,gBAAgB,EAAE,sBAAsB;EAC5C;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;EACb;EACA;IACE,WAAW;EACb;;;EAGA,gBAAgB;EAChB;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;IACE,wBAAwB,EAAE,wBAAwB;IAClD,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,gBAAgB;EAChB;IACE,gBAAgB,EAAE,oBAAoB;IACtC,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa,EAAE,4BAA4B;IAC3C,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,+BAA+B;EAC/B;MACI,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;EAC3B;;EAEA;MACI,cAAc,EAAE,QAAQ;MACxB,yBAAyB;MACzB,yBAAyB;MACzB,kBAAkB;EACtB;;EAEA;MACI,kBAAkB;EACtB;;;EAGA,0CAA0C;EAC1C;MACI,aAAa;MACb,yBAAyB,EAAE,0BAA0B;MACrD,gBAAgB;EACpB;;EAEA,mEAAmE;EACnE;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB,EAAE,0BAA0B;EAC/C;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B","sourcesContent":["/* Modal Overlay */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000; /* Should be above other elements */\n  }\n  \n  /* Modal Content */\n  .modal-content {\n    background-color: #fff;\n    padding: 30px;\n    border-radius: 8px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n    max-width: 600px; /* Or any desired width */\n    width: 90%;\n    max-height: 80vh; /* Limit height */\n    display: flex;\n    flex-direction: column;\n    position: relative;\n  }\n  \n  /* Especially for NonFeatureColumnModal */\n  .modal-content.non-feature-modal {\n      max-width: 500px; /* Slightly narrower */\n  }\n  \n  /* Close Button */\n  .close-modal-button {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    background: none;\n    border: none;\n    font-size: 2rem;\n    cursor: pointer;\n    color: #aaa;\n  }\n  .close-modal-button:hover {\n    color: #333;\n  }\n  \n  \n  /* Modal Title */\n  .modal-content h2 {\n    margin-top: 0;\n    margin-bottom: 20px;\n    text-align: center;\n    color: #333;\n  }\n  \n  /* Fetch Button */\n  .fetch-all-columns-button {\n    margin-bottom: 15px;\n    padding: 10px 15px;\n  }\n  \n  /* Search Input */\n  .search-input {\n    width: calc(100% - 22px); /* Account for padding */\n    padding: 10px;\n    margin-bottom: 15px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 1rem;\n  }\n  \n  /* Column List */\n  .column-list {\n    max-height: 40vh; /* Scroll for list */\n    overflow-y: auto;\n    border: 1px solid #eee;\n    padding: 10px;\n    margin-bottom: 20px;\n    background-color: #f9f9f9;\n  }\n  \n  /* Column Item */\n  .column-item {\n    padding: 8px 5px;\n    border-bottom: 1px solid #eee;\n  }\n  .column-item:last-child {\n    border-bottom: none;\n  }\n  \n  .column-item label {\n    display: flex; /* Align checkbox and text */\n    align-items: center;\n    cursor: pointer;\n  }\n  \n  .column-item input[type=\"checkbox\"] {\n    margin-right: 10px;\n  }\n  \n  /* Loading and Error Messages */\n  .loading-message, .error-message {\n      padding: 10px;\n      margin-bottom: 15px;\n      text-align: center;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n  }\n  \n  .error-message {\n      color: #dc3545; /* Red */\n      background-color: #f8d7da;\n      border: 1px solid #f5c6cb;\n      border-radius: 4px;\n  }\n  \n  .loading-message .spinner {\n      margin-right: 10px;\n  }\n  \n  \n  /* Modal Actions (Done button container) */\n  .modal-actions {\n      display: flex;\n      justify-content: flex-end; /* Align button to right */\n      margin-top: 15px;\n  }\n  \n  /* General Button Styling (can inherit from App.css if available) */\n  .button {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 1rem;\n    margin-left: 10px; /* Space between buttons */\n  }\n  \n  .button-primary {\n    background-color: #007bff;\n    color: white;\n  }\n  .button-primary:hover {\n    background-color: #0056b3;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
